import { createFileRoute } from '@tanstack/react-router'

import { Workflow } from '@/pages/ControlRoom/Workflow/Workflow'

export const Route = createFileRoute('/_app/control-room/workflow/$stepId/')({
  component: Workflow,
})
